/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import EventTags from 'apmui/EventTags';
import App from 'apmui/App';
import { FORM_ID, FIELD_NAME } from './Model';
import { INPUT } from 'apmui/components/form/Model';
import GetPRPQuery from 'apmui/util/GetPRPQuery';
/* Enable default event chain for forms */
import 'apmui/components/form/Controller';

const app = App.get();
/**
 * INITIAL event: load list of resources
 */
app.subscribeDefault(EventTags.CONFIGURE, (event, store) => {
    if (store.pageType !== 'decisionBox') {
        return;
    }
    // set initial values
    store.decisionBox.form = {
        id: FORM_ID,
        title: '',
        submitCaption: '',
        method: 'POST',
        fields: [
            {
                name: FIELD_NAME,
                type: INPUT.HIDDEN,
                caption: '',
                disabled: false,
                value: undefined,
            },
        ],
    };

    /* Are we in per-request AP?
     * Page URLs in per-request AP include non-empty 'state' query parameter.
     * We must use special form action with this parameter.
     */
    const query = GetPRPQuery();
    if (query) {
        store.decisionBox.form.action = '/confirm.php3?' + query;
    }
});
